
import React from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import Deferred from 'l../../share/deferred';

export class ModalDialog extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.promise = new Deferred()
    this.state = {show: true}
    this.confirmButton = React.createRef()
  }

  static defaultProps = {
    confirmLabel: 'Ja',
    abortLabel: 'Nein',
    showAbortButton: true,
    size: 'large',
    type: 'info',
    titles: {
      confirm: 'Bestätigung',
      info: 'Info',
      error: 'Fehler'
    }
  }

  // componentDidUpdate() {
  //   if(this.confirmButton) this.confirmButton.current.focus()
  // }

  abort = () => {
    this.setState({show: false}, () => this.promise.reject(true))
  }

  confirm = () => {
    this.setState({show: false}, () => this.promise.resolve(true))
  }

  render(){
    return (
      <Modal
        size='lg'
        isOpen={this.state.show}
        toggle={this.abort}
        onClosed={this.props.onHide}>
        <ModalHeader toggle={this.props.close}>
          <i className={`fas fa-dialog-title-icon ${this.props.type}`}></i>
          {this.props.titles[this.props.type]}
        </ModalHeader>

        <ModalBody>
          { this.props.title &&
            <h4>
              { this.props.title }
            </h4>
          }
          { this.props.message }
        </ModalBody>
        <ModalFooter>
          { this.props.showAbortButton && <Button onClick={this.abort}>{this.props.abortLabel}</Button>}
          <Button color='primary' onClick={this.confirm} ref={this.confirmButton}>
            {this.props.confirmLabel}
          </Button>
        </ModalFooter>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/components/dialogs/dialog.js